import React from 'react'
import { useTranslation } from 'react-i18next'

interface PartnerProps {
  name: string;
  logo: string;
  href: string;
}

const partners: PartnerProps[] = [
  {
    name: "Garmin",
    logo: "/garmin.png",
    href: "https://www.garmin.com"
  },
  {
    name: "DAN",
    logo: "/dan-world.png",
    href: "https://dan.org"
  },
  {
    name: "Dive Assure",
    logo: "/dive-assure.png",
    href: "https://www.diveassure.com"
  }
]

const PartnersSection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <section className="py-14 relative z-20">
      <div className="container">
        <p className="text-center text-sm font-medium text-muted-foreground mb-8">
          {t('home.partners.trustedBy')}
        </p>
        <div className="grid grid-cols-3 gap-8 md:gap-12 items-center justify-items-center max-w-3xl mx-auto">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
            >
              <img
                src={partner.logo}
                alt={`${partner.name} logo`}
                className="h-9 md:h-11 w-auto object-contain transition-transform group-hover:scale-105"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PartnersSection 